<div class="pricing-panel-container">
    <div class="pricing-panel-header">
        <h4>Plan Details</h4>
        <div class="action-btn">
            <itb-round-button [className]="'light'" [iconClassName]="'edit'" ></itb-round-button>
            <itb-round-button [className]="'light'" [iconClassName]="'delete'" ></itb-round-button>
        </div>
    </div>
    <div fxLayout="row" class="pricing-panel-detail-cont">
        <div class="pricing-panel-col pr-panel-1">
            <div class="item item-header">
                <h4>Premium Monthly</h4>
            </div>
            <div class="item">
                <span class="item-label">Licenses Included</span>
                <div  class="item-feature">
                    <span class="license-num">45</span>
                </div>
                <div class="item-feature-type">
                    <span>Managed Licenses</span>
                </div>               
            </div>
            <div class="item">
                <span class="item-date-txt">Date Activated</span>
                <span class="item-date">Mar 23rd, 2018</span>
            </div>
        </div>
        <div class="pricing-panel-col pr-panel-2">
            <div class="item item-header">
                <h4>Amount | $0</h4>
            </div>
            <div class="item">
                <span class="item-label">Licenses Included</span>
                <div  class="item-feature">
                    <span class="license-num"> 20</span>
                    <span class="license-info">of 45 entries</span>
                </div>
                <div class="item-feature-type">
                    <span>Managed Users</span>
                </div>               
            </div>
            <div class="item">
                <span class="item-date-txt">Date Activated</span>
                <span class="item-date">Mar 23rd, 2018</span>
            </div>
        </div>
        <div class="pricing-panel-col pr-panel-3">
            <div class="item item-header">
                <h4>Status | <span>Active</span></h4>
            </div>
            <div class="item">
                <span class="item-label">Licenses Included</span>
                <div  class="item-feature">
                    <span class="if-1">ITBSUPZERO</span>
                    <span class="if-2">Coupon Applied</span>
                </div>
                <div class="item-feature-type">
                    <span>Add Coupon</span>
                </div>               
            </div>
            <div class="item">
                <span class="item-date-txt">Date Activated</span>
                <span class="item-date">Mar 23rd, 2018</span>
            </div>
        </div>
    </div>
</div>
